export enum AllRoutes {
  Login = '/login',
  Dashboard = '/dashboard',
  BroadcastMessage = '/broadcast-message',
  VehiclesMonitoring = '/vehicles-monitoring',
  AttributeRangeDetectors = '/attribute-range-detectors',
  CommuteDetectors = '/commute-detectors',
  DevicePresenceDetectors = '/device-presence-detectors',
  DeviceProperties = '/device-properties',
  DeviceStatusDetectors = '/device-status-detectors',
  DownsampledMessageHistory = '/downsampled-message-history',
  EmployeeManager = '/employee-manager',
  FlowProcessors = '/flow-processors',
  FuelLevelProcessors = '/fuel-level-processors',
  MessagePublishers = '/message-publishers',
  MqttClients = '/mqtt-clients',
  ZoneGuards = '/zone-guards',
  Zones = '/zones',
  Issues = '/issues',
  TepManagement = '/tep-management',
  TepDevicesManagement = '/tep-devices-management',
  TepOfficersNotifications = '/tep-officers-notifications',
  TepClientNotifications = '/tep-client-notifications',
  TepHistoryReport = '/reports/tep-history',
  TepHistoryReportView = '/reports/tep-history/view',
}
